

import {
    GetCustomerLinesErrorPayLoad,
    GetCustomerLinesSuccessPayload,
    GetNoteErrorPayLoad,
    GetNoteRequestPayload,
    GetNoteSuccessPayload,
    GetNumberByCustomerIdErrorPayLoad,
    GetNumberByCustomerIdRequestPayload,
    GetNumberByCustomerIdSuccessPayload,
    SaveNoteErrorPayLoad,
    SaveNoteRequestPayload,
    SaveNoteSuccessPayload,
    SearchNumberErrorPayLoad,
    SearchNumberRequestPayload,
    SearchNumberSuccessPayload,
    UpdateStarErrorPayLoad,
    UpdateStarRequestPayload,
    UpdateStarSuccessPayload,

} from "../interfaces/secreteryMessage"

import {
    GetCustomerLinesError,
    GetCustomerLinesRequest,
    GetCustomerLinesSuccess,
    GetNoteError,
    GetNoteRequest,
    GetNoteSuccess,
    GetNumberByCostumerIdError,
    GetNumberByCostumerIdRequest,
    GetNumberByCostumerIdSuccess,
    SaveNoteError,
    SaveNoteRequest,
    SaveNoteSuccess,
    SearchNumberError,
    SearchNumberRequest,
    SearchNumberSuccess,
    UpdateStarError,
    UpdateStarRequest,
    UpdateStarSuccess,
} from "../types/secreteryMessage/actionsTypes"

import { Types } from "../types"
import { GetListPublicParamsType } from "../types/common/commonTypes"
import { CallReportDetailResponse, SecretaryCallReport } from "../interfaces/customerLine"


export const getNumberByCustomerIdRequestAction = (payload: GetNumberByCustomerIdRequestPayload): GetNumberByCostumerIdRequest => ({
    type: Types.GET_NUMBER_BY_REQUEST_ID_REQUEST,
    payload
})

export const getNumberByCustomerIdSuccessAction = (payload: GetNumberByCustomerIdSuccessPayload): GetNumberByCostumerIdSuccess => ({
    type: Types.GET_NUMBER_BY_REQUEST_ID_SUCCESS,
    payload
})

export const getNumberByCustomerIdErrorAction = (payload: GetNumberByCustomerIdErrorPayLoad): GetNumberByCostumerIdError => ({
    type: Types.GET_NUMBER_BY_REQUEST_ID_ERROR,
    payload
})
//save************************************************************************************************************************************

export const saveNoteRequestAction = (payload: SaveNoteRequestPayload): SaveNoteRequest => ({
    type: Types.SECRETARY_MESSAGE_SAVE_REQUEST,
    payload
})

export const saveNoteSuccessAction = (payload: boolean): SaveNoteSuccess => ({
    type: Types.SECRETARY_MESSAGE_SAVE_SUCCESS,
    payload
})

export const saveNoteErrorAction = (payload: SaveNoteErrorPayLoad): SaveNoteError => ({
    type: Types.SECRETARY_MESSAGE_SAVE_ERROR,
    payload
})
//getNote****************************************************************************************************************************************

export const getCallReportDetailsAction = (payload: GetNoteRequestPayload): GetNoteRequest => ({
    type: Types.SECRETARY_MESSAGE_GET_NOTE_REQUEST,
    payload
})

export const GetNoteSuccessAction = (payload: CallReportDetailResponse): GetNoteSuccess => ({
    type: Types.SECRETARY_MESSAGE_GET_NOTE_SUCCESS,
    payload
})

export const GetNoteErrorAction = (payload: GetNoteErrorPayLoad): GetNoteError => ({
    type: Types.SECRETARY_MESSAGE_GET_NOTE_ERROR,
    payload
})
//Search******************************************************************************************************************************************

export const SearchNumberRequestAction = (payload: GetListPublicParamsType): SearchNumberRequest => ({
    type: Types.SECRETARY_MESSAGE_SEARCH_REQUEST,
    payload
})

export const SearchNumberSuccessAction = (payload: SecretaryCallReport): SearchNumberSuccess => ({
    type: Types.SECRETARY_MESSAGE_SEARCH_SUCCESS,
    payload
})

export const SearchNumberErrorAction = (payload: SearchNumberErrorPayLoad): SearchNumberError => ({
    type: Types.SECRETARY_MESSAGE_SEARCH_ERROR,
    payload
})

//UpdateStar******************************************************************************************************************************************
export const UpdateStarRequestAction = (payload: UpdateStarRequestPayload): UpdateStarRequest => ({
    type: Types.SECRETARY_MESSAGE_UPDATE_STAR_REQUEST,
    payload
})

export const UpdateStarSuccessAction = (payload: boolean): UpdateStarSuccess => ({
    type: Types.SECRETARY_MESSAGE_UPDATE_STAR_SUCCESS,
    payload
})

export const UpdateStarErrorAction = (payload: UpdateStarErrorPayLoad): UpdateStarError => ({
    type: Types.SECRETARY_MESSAGE_UPDATE_STAR_ERROR,
    payload
})
//getLineCustomer**************************************************************************************************************************************
export const getCustomerLinesRequestAction = (): GetCustomerLinesRequest => ({
    type: Types.SECRETARY_GET_CUSTOMER_LINES_REQUEST
})

export const getCustomerLinesSuccessAction = (payload: GetCustomerLinesSuccessPayload): GetCustomerLinesSuccess => ({
    type: Types.SECRETARY_GET_CUSTOMER_LINES_SUCCESS,
    payload
})

export const getCustomerLinesErrorAction = (payload: GetCustomerLinesErrorPayLoad): GetCustomerLinesError => ({
    type: Types.SECRETARY_GET_CUSTOMER_LINES_ERROR,
    payload
})
//Reset***********************************************************************************************************
export const resetAction = () => ({
    type: Types.SET_RESET_SECRETARY_MESSAGE_PROPS
})

export const resetSaveNoteSuccessPropsAction = () => ({
    type: Types.RESET_SAVE_NOTE_PROPS

})